import { Pipe, PipeTransform } from '@angular/core';
import { EDalyTimeSlotLocation } from 'src/app/entities/daly-time-slot.entity/daly-time-slot';

@Pipe({
  name: 'locationEnabled'
})
export class LocationEnabledPipe implements PipeTransform {

  transform(
    value: EDalyTimeSlotLocation,
    type: 'cabinet' | 'online'
  ): boolean {

    if (value === null || value === undefined) return false;

    switch (type) {

      case 'cabinet':
        return value === EDalyTimeSlotLocation.ATSITE
            || value === EDalyTimeSlotLocation.BOTH;

      case 'online':
        return value === EDalyTimeSlotLocation.ONLINE
            || value === EDalyTimeSlotLocation.BOTH;

      default:
        return false;
    }
  }
}